module.exports = __webpack_public_path__ + "static/media/IlustraciónBannerinicial_1.30473bc3.png";